import { ConfigurationService } from './configuration.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { Global } from '../../global.constants';

@Injectable({
  providedIn: 'root'
})
export class EndpointFactory {

  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'No-Auth': 'True'
    })
  };
  public loginUrl: string;

  constructor(protected httpClient: HttpClient,
    protected configurations: ConfigurationService,
    protected injector: Injector,
    protected appConfig: AppConfigService) { }

  config: any = this.appConfig.getConfig();
  apiUrl = this.config !== undefined ? this.config.API_URL : '';

  getInitialLoginInfo(CurrentOrg) {
    const url = this.apiUrl + Global.BASE_GETINITIAL_USERINFO_ENDPOINT;
    const obj = { CurrentOrg };
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.httpClient.post<any>(url, obj, httpOptions)
      .pipe(map((response: any) => response),
        catchError(this.handleError));
  }

  handleError(error: Response) {
    const response: any = {
      success: false,
      message: Global.DisplayErrorMessage
    };
    return throwError(response);
  }
}
